import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, Input } from 'antd';
import { toggleUpdateRule } from '../../redux/actions/rule/toggleUpdateRule';
import { updateRule } from '../../redux/actions/rule/updateRule';

class UpdateRuleModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate(this.props.toUpdate?.id,values.statement,
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Rule"
                key={this.props.toUpdate?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-rule-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-rule-form"
                    name="basic"
                    initialValues={{
                        statement: this.props.toUpdate?.statement
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="statement"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.rule.ruleUpdateVisible,
    loading: state.rule.loading,
    token: state.auth.token,
    error: state.rule.error,
    message: state.rule.message,
    toUpdate:state.rule.ruleToUpdate
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (id,statement, token) => dispatch(updateRule(id,statement, token)),
    onClose: () => dispatch(toggleUpdateRule()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateRuleModal);